import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const ContentContext = createContext(null);

const EMPTY = { home: {}, about: {}, contact: {}, footer: {} };

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(EMPTY);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/content");
      setContent({
        home: data.home || {},
        about: data.about || {},
        contact: data.contact || {},
        footer: data.footer || {},
      });
    } catch (e) {
      console.error("content load error", e);
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  // Returns value for section.key with fallback
  const get = useCallback((section, key, fallback = "") => {
    const v = content?.[section]?.[key];
    return (v === undefined || v === null || v === "") ? fallback : v;
  }, [content]);

  return (
    <ContentContext.Provider value={{ content, loaded, reload: load, get }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
